import axios, { AxiosInstance } from 'axios';
import { getApiBaseUrl } from '../../services/api';

/** Axios client matching the Node scenario runner (never throws on HTTP status). */
export function createBrowserQaClient(): AxiosInstance {
  const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
  return axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': 'application/json',
    },
    validateStatus: () => true,
    timeout: 60000,
  });
}
